<template>
  <v-item-group mandatory class="mt-n1">
    <v-container >
      <v-row justify="center" >
            <!-- cols="12" xs="10" sm="6" md="3"  -->
        <v-col cols="auto"               
               v-for="(item, i) in systemMenuList" :key="i">
          <v-item >              
                  <v-card class="mx-auto rounded-xl"
                        :color="i%2 == 0 ? '#FBE9E7' : '#B9F6CA'"
                        @click="goItem({code:item.pgmId, menu: item.ename, linkUrl: item.linkAddr, menuId:item.menuId, prtId:item.prtId}) "
                        flat       
                        outlined 
                        height="160"
                        width="150"
                  >
                  <v-row>
                    <v-col cols="12" sm="6" md ="12">
                      <v-list-item three-line class="text-center">
                        <v-list-item-content>
                          <div align="center" >
                            <v-img
                              :src="item.imgButton"
                              height="65"
                              width="65"
                              contain
                            ></v-img>
                          </div>
                          <v-list-item-subtitle
                            class="caption mt-4"
                            ><span style="font-size: 11pt">  {{ item.ename }} </span>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>                   
                  </v-card>
          </v-item>                    
        </v-col>  
      </v-row>
    </v-container > 
  </v-item-group>  
</template>

<script>

import { getSystemMenu } from '@/api/system/menuManage'
import { openMenu } from '@/api/system/userManage'
import VueToastify from '@/components/toastify/VueToastify.vue'


export default {
  name: "v10Main",
  data: () => ({
    toggle_exclusive: 1,
    systemMenuList:[],
    dataInfo: null,
    userData: {
          userId: '',
          userPw: '',
          sysId: '',
          system: '',
    },
    user: {
      initials: '',
      fullName: '',
      email: ''
    },
    userInfo: null,
    active: false,       
    gridLists: [],
    image: require(`@/assets/images/bg/bg_login.jpg`),

    window: {
        w: 0,
        h: 0,
    }
  }),
  components: {
   
  },
  created() {
    this.$emit("MenuName", {code:'main', name: 'Human-Resources'}); 
    let initial = ''
        const arrName = this.$store.state.user.userNm.split(' ')
        for(let i = 0; i < arrName.length; i++) {
          initial += arrName[i].substr(0, 1)
        }

        this.user = {
          initials: initial,
          fullName: this.$store.state.user.userNm,
          makerNm: this.$store.state.user.deptNm
        }

        this.userInfo = {
          userId: this.$store.state.user.userId,
          sysCd: this.$store.state.system.sysCd,
          sysId: this.$store.state.system.sysId
        }
        
        this.setLocale()
  },
  mounted() {    
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    this.getSystemMenuList()
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {

    notifyAction(notifyInfo, action) {
      this.$EventBus.$emit('notifyAction', {
        notifyInfo,
        action
      })
    },
    getSystemMenuList(){
      this.systemMenuList = []
      let param = {
        userId: this.$store.state.user.userId,
        sysCd: this.$store.state.system.sysCd
      }

      //console.log(param) ;

      getSystemMenu(param).then(res => {        
        this.systemMenuList = res.list
      })
    },

    goItem(obj) {            

       //-------------------Login History----------------------------
       let params = {

        menuId: obj.menuId,
        prtId: obj.prtId,
        jspNm: obj.menu + '(' + obj.code + ')',
        userId: this.$store.state.user.userId
        } 

        //console.log("Open Menu: " ,  params)
        
        openMenu(params).then(res => {    
          })

        //-------------------Login History----------------------------
      this.$emit("MenuName", {code:this.$store.state.system.sysCd, name: obj.menu}); 

      if(obj.code==''||obj.code == null){
        this.snackbar = true        
      }else{
        //console.log("ObjectCode Menu: " + obj.code)
        this.$router.push("/" + obj.code).catch(e => {
        this.vToastify(this.$t('View does not exist.'), 'warn')
        // if (!isNavigationFailure(e, NavigationFailureType.redirected))
        //   Promise.reject(e);
        });
      }
    },

    setLocale() {
      this.activeLang = this.$envs.framework.supportLocales.en
      this.$vuetify.lang.current = 'en'
      this.$i18n.locale = 'en'
      this.$store.dispatch('GetGridMenu', this.userInfo)
      this.$EventBus.$emit('lanCode', this.$localStore.get('locale'))  
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
      if(this.windowWidth <= '569' ){
        this.window.w   = 65;
        this.window.h   = 65;
      }else{
        this.window.w   = 75;
        this.window.h   = 75;
      }
      this.$store.dispatch('app/setIsScreenFull', window.innerHeight == screen.height)
    },
  }
}  

</script>

<style>
</style>